<template>
  <div class="MedicalAdvie">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>远程医疗</el-breadcrumb-item>
          <el-breadcrumb-item>医疗咨询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>医疗咨询</h3>
    </div>
    <div class="table-content">
      <div class="warning">
        <h1>请注意!</h1>
        <p>医疗咨询服务由“云ICU”提供，请先拨打400-855-4120预约!</p>
      </div>
      <div
        class="join"
        @click="join()"
      >
        确认进入
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MedicalAdvice",
  methods: {
    join() {
      window.open("icuWebshell:\\");
    }
  }
};
</script>

<style scoped lang="less">
.MedicalAdvie {
  .el-breadcrumb {
    display: inline-block;
  }
  .table-content {
    height: 100%;
    .warning {
      background-color: #fefae7;
      border: 1px solid #feef89;
      padding: 20px 40px;
      margin-bottom: 100px;
      h1 {
        font-size: 35px;
      }
      p {
        padding: 10px 0px;
      }
    }
    .join {
      background-color: #1790ff;
      color: white;
      text-align: center;
      height: 50px;
      line-height: 50px;
      margin: 0 auto;
      width: 250px;
      border-radius: 5px;
      font-size: 30px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/MedicalAdvice.vue